import '@procuai/ui/tokens.css';
import '@procuai/ui/shell.css';
import '@procuai/ui/mobile.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { IconSprite } from '@procuai/ui';
import { router } from './router.js';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } });

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <IconSprite />
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
